import { render, staticRenderFns } from "./JustificativaIcone.vue?vue&type=template&id=6b0d1482&scoped=true"
import script from "./JustificativaIcone.vue?vue&type=script&lang=js"
export * from "./JustificativaIcone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d1482",
  null
  
)

export default component.exports